// src/guide/compte/guide_modifier_mdp.js
import {
  guide_tour_init,
  guide_tour_step_start,
  guide_tour_step,
  guide_tour_step_complete,
} from "@/guide/utils/guide_tour_actions";

export async function guide_modifier_mdp(langs) {
  let translations;
  try {
    // Charge dynamiquement le JSON correspondant (ex: guide_traduction_fr.json)
    translations = (
      await import(`@/guide/traductions/guide_traduction_${langs}.json`)
    ).default;
  } catch (error) {
    console.error(
      "Erreur lors du chargement des traductions pour la langue",
      langs,
      error
    );
    return;
  }
  const tour = guide_tour_init();

  if (document.getElementById("ancien_mdp")) {
    guide_tour_step_start(
      tour,
      translations,
      translations.compte.coordonnees.modifier_mdp.ancien_mdp.titre,
      translations.compte.coordonnees.modifier_mdp.ancien_mdp.texte,
      "#ancien_mdp",
      "bottom"
    );

    guide_tour_step(
      tour,
      translations,
      translations.compte.coordonnees.modifier_mdp.nouveau_mdp.titre,
      translations.compte.coordonnees.modifier_mdp.nouveau_mdp.texte,
      "#nouveau_mdp",
      "bottom"
    );
  } else {
    guide_tour_step_start(
      tour,
      translations,
      translations.compte.coordonnees.modifier_mdp.nouveau_mdp.titre,
      translations.compte.coordonnees.modifier_mdp.nouveau_mdp.texte,
      "#nouveau_mdp",
      "bottom"
    );
  }

  guide_tour_step(
    tour,
    translations,
    translations.compte.coordonnees.modifier_mdp.confirmation_nouveau_mdp.titre,
    translations.compte.coordonnees.modifier_mdp.confirmation_nouveau_mdp.texte,
    "#confirmation_nouveau_mdp",
    "bottom"
  );

  guide_tour_step_complete(
    tour,
    translations,
    translations.compte.coordonnees.modifier_mdp.valider_modification_mdp.titre,
    translations.compte.coordonnees.modifier_mdp.valider_modification_mdp.texte,
    "#valider_modification_mdp",
    "top"
  );

  tour.start();
}
